
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/spotlights/[slug]",
      function () {
        return require("private-next-pages/spotlights/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/spotlights/[slug]"])
      });
    }
  